module.exports = __webpack_public_path__ + "img/icn_ubicacion.5da9dc44.svg";